export default "<p>devicepos-admin works!</p>\n";